var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1290_6171)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8153 17.8714L19.9946 12.6944L25.1761 17.8757L28.1881 14.8617L19.9946 6.66638L11.8012 14.8596L14.8153 17.8714ZM6.67969 20.0003L9.69267 16.9874L12.7057 20.0003L9.69267 23.0131L6.67969 20.0003ZM19.9989 27.3069L14.8195 22.1277L11.8012 25.1375L11.8054 25.1417L19.9989 33.3328L28.1923 25.1375L28.1944 25.1354L25.1803 22.1256L19.9989 27.3069ZM27.322 20.0008L30.335 16.9879L33.348 20.0008L30.335 23.0137L27.322 20.0008ZM20.0179 16.9404L23.0741 19.9986H23.0762L23.0741 20.0007L20.0179 23.0589L16.9617 20.0049L16.9575 19.9986L16.9617 19.9944L17.4967 19.4594L17.7579 19.2003L20.0179 16.9404Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_6171",
    x1: 40,
    y1: 40,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD632"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.a688390a14754429192ce66d21b4e4a4.svg";
export { ForwardRef as ReactComponent };